/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from '@servicetitan/application-data/common-interfaces';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface ILegacyCampaign {
    getCampaignCategories(fetchOnlyActive: boolean | undefined, cancelToken?: CancelToken): AxiosPromise<CampaignCategoryResultModel[]>;
    setIsCampaignCategoryRequired(isCampaignCategoryRequired: boolean, cancelToken?: CancelToken): AxiosPromise<void>;
    getCampaignCategory(id: number, cancelToken?: CancelToken): AxiosPromise<CampaignCategoryResultModel>;
    editCampaignCategory(model: CampaignCategoryCreateUpdateModel, cancelToken?: CancelToken): AxiosPromise<void>;
    setCampaignCategoryIsActive(id: number, isActive: boolean, cancelToken?: CancelToken): AxiosPromise<void>;
    getCampaigns(cancelToken?: CancelToken): AxiosPromise<CampaignResultModel[]>;
    getCampaign(id: number, cancelToken?: CancelToken): AxiosPromise<EditCampaignModel>;
    editCampaign(model: BaseEditCampaignModel, cancelToken?: CancelToken): AxiosPromise<number>;
    setCampaignIsActive(id: number, isActive: boolean, cancelToken?: CancelToken): AxiosPromise<void>;
    activateDeactivateCampaigns(ids: number[], activate: boolean, cancelToken?: CancelToken): AxiosPromise<number[]>;
    toggleDefaultCampaign(id: number, isDefaultCampaign: boolean, cancelToken?: CancelToken): AxiosPromise<void>;
}

export const BASE_URL_TOKEN_LegacyCampaign = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class LegacyCampaign implements ILegacyCampaign {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_LegacyCampaign) @optional() private readonly baseUrl = "") {
    }

    getCampaignCategories(fetchOnlyActive: boolean | undefined, cancelToken?: CancelToken): AxiosPromise<CampaignCategoryResultModel[]> {
        let url_ = "/Settings/GetCampaignCategories?";
        if (fetchOnlyActive === null)
            throw new Error("The parameter 'fetchOnlyActive' cannot be null.");
        else if (fetchOnlyActive !== undefined)
            url_ += "fetchOnlyActive=" + encodeURIComponent("" + fetchOnlyActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CampaignCategoryResultModel[]>(options_));
    }

    setIsCampaignCategoryRequired(isCampaignCategoryRequired: boolean, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/Settings/SetIsCampaignCategoryRequired?";
        if (isCampaignCategoryRequired === undefined || isCampaignCategoryRequired === null)
            throw new Error("The parameter 'isCampaignCategoryRequired' must be defined and cannot be null.");
        else
            url_ += "isCampaignCategoryRequired=" + encodeURIComponent("" + isCampaignCategoryRequired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    getCampaignCategory(id: number, cancelToken?: CancelToken): AxiosPromise<CampaignCategoryResultModel> {
        let url_ = "/Settings/GetCampaignCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CampaignCategoryResultModel>(options_));
    }

    editCampaignCategory(model: CampaignCategoryCreateUpdateModel, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/Settings/EditCampaignCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    setCampaignCategoryIsActive(id: number, isActive: boolean, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/Settings/SetCampaignCategoryIsActive?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined and cannot be null.");
        else
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    getCampaigns(cancelToken?: CancelToken): AxiosPromise<CampaignResultModel[]> {
        let url_ = "/Settings/GetCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CampaignResultModel[]>(options_));
    }

    getCampaign(id: number, cancelToken?: CancelToken): AxiosPromise<EditCampaignModel> {
        let url_ = "/Settings/GetCampaign/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<EditCampaignModel>(options_));
    }

    editCampaign(model: BaseEditCampaignModel, cancelToken?: CancelToken): AxiosPromise<number> {
        let url_ = "/Settings/EditCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<number>(options_));
    }

    setCampaignIsActive(id: number, isActive: boolean, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/Settings/SetCampaignIsActive?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined and cannot be null.");
        else
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    activateDeactivateCampaigns(ids: number[], activate: boolean, cancelToken?: CancelToken): AxiosPromise<number[]> {
        let url_ = "/Settings/ActivateDeactivateCampaigns?";
        if (activate === undefined || activate === null)
            throw new Error("The parameter 'activate' must be defined and cannot be null.");
        else
            url_ += "activate=" + encodeURIComponent("" + activate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = ids;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<number[]>(options_));
    }

    toggleDefaultCampaign(id: number, isDefaultCampaign: boolean, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/Settings/ToggleDefaultCampaign?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isDefaultCampaign === undefined || isDefaultCampaign === null)
            throw new Error("The parameter 'isDefaultCampaign' must be defined and cannot be null.");
        else
            url_ += "isDefaultCampaign=" + encodeURIComponent("" + isDefaultCampaign) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }
}

export interface CampaignCategoryResultModel {
    id: number;
    name: string;
    active: boolean;
}

export interface CampaignCategoryCreateUpdateModel {
    id?: number | undefined;
    name: string;
    active?: boolean | undefined;
}

export interface CampaignResultModel {
    id: number;
    externalId?: number | undefined;
    image?: string | undefined;
    name: string;
    businessUnit?: string | undefined;
    dnis: string[];
    active: boolean;
    isDefaultCampaign?: boolean | undefined;
    category?: string | undefined;
    running: boolean;
}

export interface BaseEditCampaignModel {
    id: number;
    isDefaultCampaign?: boolean | undefined;
    name: string;
    businessUnitId: number;
    image?: string | undefined;
    source?: string | undefined;
    medium?: string | undefined;
    otherSource?: string | undefined;
    otherMedium?: string | undefined;
    dnis?: string | undefined;
    categoryId: number;
}

export interface EditCampaignModel extends BaseEditCampaignModel {
    businessUnitName?: string | undefined;
    active?: boolean | undefined;
    categoryName?: string | undefined;
    allCampaignCategories?: CampaignCategoryModel[] | undefined;
    running: boolean;
}

export interface CampaignCategoryModel {
    id: number;
    name: string;
    active: boolean;
    type: CampaignCategoryType;
    createdOn: Date;
    modifiedOn: Date;
}

export enum CampaignCategoryType {
    Regular = 0,
    GoogleHomeServices = 1,
}
